// A meeting tab can be shown for a whole family, a single individual client, or
// the practice-wide meetings hub (all clients). The shared meeting components are
// parameterised by this scope so the same implementation drives every screen.
export type MeetingScope =
  | { kind: 'family'; familyId: string }
  | { kind: 'individual'; clientId: string }
  | { kind: 'all' };

export function meetingScopeFromParams(params: {
  familyId?: string;
  clientId?: string;
}): MeetingScope {
  if (params.familyId) return { kind: 'family', familyId: params.familyId };
  if (params.clientId) return { kind: 'individual', clientId: params.clientId };
  return { kind: 'all' };
}

export function meetingsBasePath(scope: MeetingScope): string {
  switch (scope.kind) {
    case 'family':
      return `/family/${scope.familyId}/meetings`;
    case 'individual':
      return `/client/${scope.clientId}/meetings`;
    case 'all':
      return '/meetings';
  }
}

export function meetingDetailPath(scope: MeetingScope, eventId: string): string {
  switch (scope.kind) {
    case 'family':
      return `/family/${scope.familyId}/meeting/${eventId}`;
    case 'individual':
      return `/client/${scope.clientId}/meeting/${eventId}`;
    case 'all':
      return `/meetings/${eventId}`;
  }
}

export function assignSpeakerPath(
  scope: MeetingScope,
  eventId: string,
  speakerLabel: string,
): string {
  const label = encodeURIComponent(speakerLabel);
  switch (scope.kind) {
    case 'family':
      return `/family/${scope.familyId}/meetings/${eventId}/speakers/${label}`;
    case 'individual':
      return `/client/${scope.clientId}/meetings/${eventId}/speakers/${label}`;
    case 'all':
      return `/meetings/${eventId}/speakers/${label}`;
  }
}
